// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"434c288b","111":"b948d9e8","198":"5b80c381","219":"142d1957","415":"c90e2b93","826":"7dbd065b","868":"a893e38f","880":"0580f48e","998":"f9a4693c","999":"2ef29303"}[chunkId] + ".chunk.js";
};